import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import logo from "./assets/logo.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetMyRolesQuery } from "entitites/casdoor/api/casdoorApi";
import { useState } from "react";

export const Header = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const { data: roles } = useGetMyRolesQuery();
  let filename: string | undefined = "";
  return (
    <AppBar sx={{ bgcolor: "#DFDFFF" }} elevation={0} position="static">
      <Box
        bgcolor="#E7E9F199"
        position="absolute"
        display={isLoading ? "flex" : "none"}
        component="div"
        width="100%"
        height="100%"
        zIndex={1800}
        justifyContent="center"
        alignItems="center"
      >
        <CircularProgress sx={{ zIndex: 1900 }} size="30vh" />
      </Box>
      <Container maxWidth="xl">
        <Toolbar variant="dense" disableGutters>
          <img alt="logo" height={36} src={logo}></img>
          <Typography
            onClick={() => {
              navigate("");
            }}
            sx={{
              cursor: "pointer",
              borderBottom: pathname.includes("/teams")
                ? "0px"
                : "2px solid #9696E2",
              color: pathname.includes("/teams") ? "#201D15" : "#42487C",
            }}
            ml="58px"
          >
            Штатное расписание
          </Typography>
          <Typography
            sx={{
              cursor: "pointer",
              borderBottom: !pathname.includes("/teams")
                ? "0px"
                : "2px solid #9696E2",
              color: !pathname.includes("/teams") ? "#201D15" : "#42487C",
            }}
            ml="30px"
            onClick={() => {
              navigate("/teams");
            }}
          >
            Команды
          </Typography>
          {Boolean(roles?.includes("staffdesk-admin")) && (
            <Button
              onClick={() => {
                setIsLoading(true);
                fetch(
                  `https://staffdesk-go.staffdesk.workround.tech/api/employees/data/export/go`
                )
                  .then((res) => {
                    const now = new Date();

                    const pad = (num: number) =>
                      num.toString().padStart(2, "0");

                    const year = now.getFullYear();
                    const month = pad(now.getMonth() + 1);
                    const day = pad(now.getDate());
                    const hours = pad(now.getHours());
                    const minutes = pad(now.getMinutes());
                    const seconds = pad(now.getSeconds());

                    filename = `Report-${year}-${month}-${day}T${hours}_${minutes}_${seconds}.csv`;

                    return res.blob();
                  })
                  .then((blob) => {
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = `${filename}`;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    setIsLoading(false);
                  })
                  .catch((err) => setIsLoading(false));
              }}
              variant="contained"
              // color="success"
              size="small"
              sx={{
                ml: "auto",
                textTransform: "none",
                minWidth: 100,

                fontWeight: 700,
              }}
              disabled={isLoading}
              disableElevation
            >
              Выгрузить .csv
            </Button>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};
